import { SignInButton } from '@clerk/clerk-react';
import { motion } from 'framer-motion';

export function CTASection() {
  return (
    <section className="py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.6 }}
          className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12 text-white"
        >
          <h2 className="text-3xl font-bold mb-4">
            Ready to start building?
          </h2>
          <p className="text-lg text-gray-300 mb-8">
            Sign in to explore the live demo and see how everything works together.
          </p>
          <SignInButton mode="modal">
            <button className="px-8 py-3 bg-white text-gray-900 rounded-xl font-medium hover:bg-gray-100 transition-colors">
              Access Demo
            </button>
          </SignInButton>
        </motion.div>
      </div>
    </section>
  );
}